import React, { useEffect, useState } from 'react';
import { FetchType } from '../../../../../enums';
import { useAppActions } from '../../../../../overmind';
import { PagePath } from '../../../../../navigation/navigation.enums';
import { CascadingPanel, CascadingPanels, useCascadingPanelsConnector } from '@keplerco/core';
import { FreemiumManagePersonCascadingPanelIds, IFreemiumManagePersonCascadingPanelsProps } from './freemium-manage-person-panels.models';
import { FreemiumManagePersonFocusPanel } from './manage-person-focus-panel/freemium-manage-person-focus-panel';
import { GetUserDto } from '../../../../../models/view/employee';

export function ManagePersonCascadingPanels(props: IFreemiumManagePersonCascadingPanelsProps): JSX.Element {
  const actions = useAppActions();

  const { openPanelIds, next, close } = useCascadingPanelsConnector();

  const [person, setPerson] = useState<GetUserDto>();
  async function getPerson(personId: string): Promise<GetUserDto | undefined> {
    const data = await actions.freemiumGetPerson(personId);
    setPerson(data);
    return data;
  }

  useEffect(() => {
    next(FreemiumManagePersonCascadingPanelIds.Sections);
  }, []);

  useEffect(() => {
    async function getData(): Promise<void> {
      if (!props.personId) return;
      actions.startLoader({ path: PagePath.freemiumUserManagementPeople, type: FetchType.DialogFetching });
      await getPerson(props.personId);
      actions.stopLoader(PagePath.freemiumUserManagementPeople);
    }

    getData();
  }, [props.personId]);

  return (
    <CascadingPanels
      openPanelIds={openPanelIds}
      onClosePanel={id => {
        close(id);
        if (id === FreemiumManagePersonCascadingPanelIds.Sections || openPanelIds.length <= 1) props.onCancel();
      }}
    >
      <CascadingPanel id={FreemiumManagePersonCascadingPanelIds.Sections}>
        <FreemiumManagePersonFocusPanel
          person={person}
          onClickSection={section => next(section)}
          onCancel={props.onCancel}
          onSave={async () => {
            actions.startLoader({ path: PagePath.freemiumUserManagementPeople, type: FetchType.DialogFetching });
            props.onCancel();
          }}
        />
      </CascadingPanel>
    </CascadingPanels>
  );
}

